import React, { useState, useEffect } from "react";
import Logo from "./logo_amservices.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDesktop, faWifi, faPhone, faCode, faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import "./header.css";
import { NavLink } from "react-router-dom";
import SubMenuInformatique from "./Menu/SubmenuInformatique";
import SubMenuTelephonie from "./Menu/SubmenuTelephonie";
import SubMenuInternet from "./Menu/SubmenuInternet";  
import SubMenuLogiciel from "./Menu/SubmenuLogiciel";
import SubMenuDev from "./Menu/SubmenuDev";
import Instagram from './instagram.png';
import Linkedin from './Linkedin.png';
import Facebook from './facebook.png';

const Headers = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Détecter le scroll pour changer le style du header
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`cyber-header ${isScrolled ? "scrolled" : ""}`}>
      {/* Barre supérieure discrète pour les réseaux */}
      <div className="top-mini-bar">
        <div className="top-socials">
          <a href="https://facebook.com" target="_blank" rel="noreferrer"><img src={Facebook} alt="FB" /></a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer"><img src={Instagram} alt="IG" /></a>
          <a href="https://linkedin.com" target="_blank" rel="noreferrer"><img src={Linkedin} alt="IN" /></a>
        </div>
      </div>

      {/* Capsule Principale de Navigation */}
      <div className="header-capsule">
        <div className="logo-section">
          <NavLink to="/">
            <img src={Logo} className="cyber-logo" alt="AM Services" />
          </NavLink>
        </div>

        <button className="burger-menu" onClick={() => setIsOpen(!isOpen)}>
          <FontAwesomeIcon icon={isOpen ? faXmark : faBars} />
        </button>

        <nav className={`nav-container ${isOpen ? "mobile-active" : ""}`}>
          <div className="menu-items">
            <div className="menu-item-with-icon">
              <FontAwesomeIcon icon={faDesktop} className="nav-cyber-icon" />
              <SubMenuInformatique />
            </div>
            <div className="menu-item-with-icon">
              <FontAwesomeIcon icon={faWifi} className="nav-cyber-icon" />
              <SubMenuInternet />
            </div>
            <div className="menu-item-with-icon">
              <FontAwesomeIcon icon={faPhone} className="nav-cyber-icon" />
              <SubMenuTelephonie />
            </div>
            <div className="menu-item-with-icon">
              <FontAwesomeIcon icon={faCode} className="nav-cyber-icon" />
              <SubMenuLogiciel />
            </div>
            
            <div className="menu-item-with-icon">
              <FontAwesomeIcon icon={faCode} className="nav-cyber-icon" />
              <SubMenuDev />
            </div>
          </div>

          <div className="action-cluster">
            <button className="cyber-btn btn-anydesk-neon" onClick={() => window.open("https://media.amservices.eu/AnyDesk.exe", "_blank")}>
              Dépannage AnyDesk
            </button>
            <button className="cyber-btn btn-supremo-neon" onClick={() => window.open("https://media.amservices.eu/AMS_Support.exe", "_blank")}>
              Dépannage Supremo
            </button>
            <NavLink to="/techgame" className="cyber-btn btn-runner-neon">
              <img src="/assets/hero_run1.png" alt="runner" className="runner-sprite" />
              <span>Tech Runner</span>
            </NavLink>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Headers;